module.exports = __webpack_public_path__ + "images/avater_default.png";